module.exports = "<app-artist [searchKey]=\"searchKey\" *ngIf=\"searchKey!==''\"></app-artist>"